__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/eb7d61b/_next/";